/** Format seconds as "Xh Ym" (or "Ym" / "Xs" for short intervals). */
export function formatDuration(totalSecs: number): string {
  const secs = Math.max(0, Math.round(totalSecs));
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  if (hours > 0) {
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
  if (minutes > 0) {
    return `${minutes}m`;
  }
  return `${secs}s`;
}

/** Ratio [0,1] → porcentaje entero. */
export function toPercent(ratio: number): number {
  return Math.round(ratio * 100);
}
